import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import es from './locales/es.json'

/**
 * Humania se vende a empresas de varios países, así que ningún texto se escribe
 * directamente en un componente: todo pasa por aquí desde el primer día. Añadir
 * un idioma después es barato; extraer cadenas incrustadas, no.
 */
export const SUPPORTED_LOCALES = [
  { code: 'es', label: 'Español' },
  { code: 'en', label: 'English' },
]

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: import.meta.env.VITE_DEFAULT_LOCALE || 'es',
    supportedLngs: SUPPORTED_LOCALES.map((l) => l.code),
    nonExplicitSupportedLngs: true, // es-CO, es-MX... resuelven a 'es'
    interpolation: { escapeValue: false }, // React ya escapa
    detection: {
      order: ['querystring', 'cookie', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['cookie'],
    },
  })

export default i18n
